var map = {
	"./0.jpg": 2716,
	"./1.jpg": 812,
	"./2.jpg": 1256,
	"./3.jpg": 3396,
	"./4.jpg": 1328,
	"./5.jpg": 9084,
	"./6.jpg": 5952,
	"./7.jpg": 7304,
	"./8.jpg": 4324,
	"./9.jpg": 6400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3476;